//NOTE: I'm not sure if it's the correct place
// but we need to have a place to store all the routes in one
// place in case we need to change them in the future / use them in multiple places
export const accountsRoutes = {
  allAccounts: '/accounts',
  selfDirected: '/accounts/self-directed/portfolio',
  tradIra: '/accounts/trad-ira/portfolio',
  rothIra: '/accounts/roth-ira/portfolio',
};
